<div class="flex flex-col gap-6 p-6">
  <sm-page-header [breadcrumb]="breadcrumb" [title]="'clarification.answer_question' | translate"></sm-page-header>

  <ng-container *ngIf="!(loading$ | async); else loader">
    <div class="flex flex-row gap-5">
      <!-- Form -->
      <div class="content w-3/4">
        <sm-form-builder *ngIf="formObject" [formObject]="formObject"></sm-form-builder>
      </div>

      <!-- Meta Blocks -->
      <div class="flex flex-col gap-2 w-1/4">
        <sm-status [status]="'clarification.status.' + status" [extra]="taskName | translate"></sm-status>
        
        <div class="content h-fit flex flex-col gap-4">
          <div *ngFor="let blocks of controlBlocks">
            <sm-block-builder [blocks]="blocks"></sm-block-builder>
          </div>
          
          <div class="mt-2 p-3 bg-blue-50 dark:bg-blue-900/20 rounded text-sm text-blue-700 dark:text-blue-300">
             <i class="pi pi-info-circle mr-2"></i>
             {{ (selectedQuestionsCount | async) }} {{ 'clarification.table.questions_count' | translate }} sélectionnée(s)
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loader>
    <div class="flex justify-center items-center p-20">
      <sm-spinner></sm-spinner>
    </div>
  </ng-template>
</div>
